import { TAGS } from '~/constants/edf';

export const POSITIONS_ORDER = [TAGS.UPRIGHT, TAGS.SUPINE, TAGS.NONSUPINE];
